import React, { useState } from 'react';
import styled from '@emotion/styled';
import { StaticQuery, graphql, navigate } from 'gatsby';
import Link from './link';
import Arrow from './images/opened';

const Wrapper = styled('div')`
  display: none;
  position: relative;
  width: 100%;
  height: 0.66rem;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;

const Select = styled('div')`
  position: absolute;
  top: 0.16rem;
  left: 0.2rem;
  right: 0.2rem;
  min-height: 0.5rem;
  background: #ebedf2;
  border: 0.01rem solid rgba(0, 0, 0, 0.1);
  border-radius: 0.08rem;
  overflow: hidden;
  z-index: 9999;
  &.active {
    box-shadow: 0 0.08rem 0.24rem -0.06rem rgba(4, 8, 16, 0.15);
  }
  .path {
    display: block;
    position: relative;
    padding: 0 0.58rem 0 0.12rem;
    height: 0.5rem;
    line-height: 0.5rem;
    font-weight: 500;
    font-size: 0.18rem;
    color: rgba(0, 0, 0, 0.5);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    svg {
      position: absolute;
      top: 0.16rem;
      right: 0.12rem;
      width: 0.18rem;
      height: 0.18rem;
      transition: transform 0.2s ease;
    }
    &.active svg {
      transform: rotate(180deg);
    }
  }
  .list {
    display: none;
    background: #ffffff;
    overflow: hidden;
    &.showed {
      display: block;
    }
    .list-tab {
      display: flex;
      align-items: center;
      display-wrap: nowrap;
      padding: 0.18rem 0.16rem;
      font-weight: 500;
      font-size: 0.14rem;
      line-height: 0.18rem;
      color: rgba(0, 0, 0, 0.4);
      border-bottom: 0.01rem solid rgba(15, 34, 67, 0.05);
      .tab {
        position: relative;
        padding-right: 0.12rem;
        max-width: 70%;
        height: 0.18rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
        &.active {
          flex-shrink: 0;
          color: rgba(0, 0, 0, 0.8);
        }
        &::after {
          content: '/';
          display: block;
          position: absolute;
          top: 0;
          right: 0.04rem;
        }
        &:last-child {
          padding-right: 0;
          ::after {
            display: none;
          }
        }
      }
    }
    .list-content {
      padding: 0 0.16rem 0.16rem;
      .link {
        display: block;
        padding: 0.16rem 0.1rem;
        font-weight: 500;
        font-size: 0.16rem;
        line-height: 1.3;
        color: rgba(0, 0, 0, 0.6);
        border-bottom: 0.01rem solid rgba(15, 34, 67, 0.05);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
        &.active {
          font-weight: 600;
          color: #3e6cff;
          background: rgba(62, 108, 255, 0.1);
        }
        &.root {
          display: inline-block;
          margin: 0.16rem 0.12rem 0.16rem 0;
          padding: 0;
          width: 1.07rem;
          height: 0.34rem;
          line-height: 0.34rem;
          font-weight: 500;
          font-size: 0.14rem;
          text-align: center;
          color: rgba(0, 0, 0, 0.7);
          border: 0.01rem solid rgba(0, 0, 0, 0.1);
          border-radius: 1rem;
          &.active {
            color: #ffffff;
            background: #3e6cff;
          }
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
`;

const Menu = ({ location }) => (
  <StaticQuery
    query={graphql`
      query {
        allMdx {
          edges {
            node {
              fields {
                slug
                order
                title
              }
            }
          }
        }
      }
    `}
    render={({ allMdx }) => {
      const links = [];
      allMdx.edges.sort((a, b) => a.node.fields.order - b.node.fields.order);
      allMdx.edges.map((item) => {
        if (item.node.fields.slug !== '/') {
          const paths = item.node.fields.slug.split('/');
          links.push({
            name: item.node.fields.title,
            slug: item.node.fields.slug,
            level: paths.length - 1,
          });
        }
      });
      const nowLink = links.filter((item) => location.pathname.includes(item.slug));
      nowLink.sort((a, b) => a.level - b.level);
      const path = nowLink.map((item) => item.name).join(' / ');
      let [isOpened, setOpened] = useState(false);
      let [toLink, setToLink] = useState(nowLink);
      let [activeTabIndex, setActiveTabIndex] = useState(toLink.length - 1);
      return (
        <Wrapper>
          <Select className={isOpened ? 'active' : ''}>
            <a
              href="#"
              className={`path ${isOpened ? ' active' : ''}`}
              onClick={() => setOpened(!isOpened)}
            >
              {path}
              <Arrow />
            </a>
            <div className={`list ${isOpened ? ' showed' : ''}`}>
              <div className="list-tab">
                {toLink.map((item, index) => {
                  return (
                    <div
                      key={index}
                      onClick={() => setActiveTabIndex(index)}
                      className={`tab ${index === activeTabIndex ? ' active' : ''}`}
                    >
                      <span className="name">{item.name}</span>
                    </div>
                  );
                })}
              </div>
              <div className="list-content">
                {links.map((item, index) => {
                  if (
                    item.level === activeTabIndex + 1 &&
                    (activeTabIndex === 0 || item.slug.includes(toLink[activeTabIndex - 1].slug))
                  ) {
                    return (
                      <div
                        key={index}
                        className={`link ${item.level === 1 ? 'root' : ''} ${
                          toLink[activeTabIndex] && item.slug === toLink[activeTabIndex].slug
                            ? 'active'
                            : ''
                        }`}
                        onClick={() => {
                          const children = links.filter(
                            (child) => child.slug !== item.slug && child.slug.includes(item.slug)
                          );
                          toLink.splice(activeTabIndex);
                          setToLink([...toLink, item]);
                          if (children.length > 0) {
                            setActiveTabIndex(activeTabIndex + 1);
                          } else {
                            setOpened(!isOpened);
                            navigate(item.slug);
                          }
                        }}
                      >
                        {item.name}
                      </div>
                    );
                  }
                })}
              </div>
            </div>
          </Select>
        </Wrapper>
      );
    }}
  />
);

export default Menu;
